module.exports = __webpack_public_path__ + "static/Background-mla-1.e962ba50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-mla-1.jpg
// module id = 470
// module chunks = 172546399187757